// Port of api/fuel/app/classes/enum.php
// Static lookup arrays used throughout the codebase.

export default {

	// Maps log type string to log model class name
	log_class: {
		'rating': 'log/user/rating',
		'collection': 'log/user/collection',
		'initiated': 'log/user/initiated',
		'registered': 'log/user/registered',
		'play': 'log/user/play',
		'group': 'log/user/group',
		'member': 'log/user/member',
		'hindex': 'log/user/hindex',
		'listing': 'log/user/listing',
		'edition': 'log/user/edition',
		'comment': 'log/user/comment',
		'buddy': 'log/user/buddy',
		'buddies': 'log/user/buddies',
		'status': 'log/user/collection/status',
		'tag': 'log/user/tag',
		'tag_attach': 'log/user/tag/attach'
	},

	// Status name -> constant
	collection_status_constant: {
		'own': 1,
		'prevowned': 2,
		'fortrade': 3,
		'want': 4,
		'wanttoplay': 5,
		'wanttobuy': 6,
		'wishlist': 7,
		'preordered': 8,
		'hasparts': 9,
		'wantparts': 10
	},

	// Status name -> DB column name
	collection_status_field: {
		'own': 'collection_own',
		'prevowned': 'collection_prevowned',
		'fortrade': 'collection_fortrade',
		'want': 'collection_want',
		'wanttoplay': 'collection_wanttoplay',
		'wanttobuy': 'collection_wanttobuy',
		'wishlist': 'collection_wishlist',
		'preordered': 'collection_preordered',
		'hasparts': 'collection_hasparts',
		'wantparts': 'collection_wantparts'
	}

}
